<template>
  <div class="indivdual-all-lbe">
    <div class="goods-body-container">
      <div class="goods-body-box">
        <div class="goods-container-row">
          <div class="goods-box">
            <div class="account-tittle-bac">
              <div class="account-screening">
                <div class="even-more" v-show="allAccountInfoData.length > 0" style="display: flex">
                  <el-radio-group v-model="radioLabel" size="mini" @change="runkChange">
                    <el-radio-button v-for="item in allAccountInfoData.slice(
                      0,
                      allAccountInfoDataIndex
                    )" :key="item.id" :label="item.id">{{ item.name }}</el-radio-button>
                  </el-radio-group>
                </div>
                <div class="even-more" v-show="allAccountInfoData.length == 0"
                  style="display: flex; width: 100%; justify-content: center">
                  {{ aaa }}
                </div>
                <div class="few-list" v-show="allAccountInfoData.length > 7">
                  <div style="display: none" ref="upRef">
                    <el-button type="primary" @click="upClick">收起 <i class="el-icon-arrow-up"></i></el-button>
                  </div>
                  <div style="display: flex" ref="downRef">
                    <el-button type="primary" @click="downClick">更多<i class="el-icon-arrow-down"></i></el-button>
                  </div>
                </div>
              </div>
              <div class="goods-tittle">
                <span>帐户概括 </span>
                <!-- <div>{{ this.timeArr }}</div> -->
              </div>
              <div class="account-ove" v-show="allAccountInfoData.length > 0">
                <div v-show="accountShow" class="account-overview">
                  <div class="account-overview-td">
                    <span>总净值</span>
                    <div>
                      {{ this.formatNum(this.assetsArr.asset) }}
                    </div>
                  </div>
                  <div class="account-overview-td">
                    <span>收益</span>
                    <div>{{ this.formatNum(this.assetsArr.earning) }}</div>
                  </div>
                  <div class="account-overview-td">
                    <span>收益率</span>
                    <div :style="{
                      color: this.setNumberColor(this.assetsArr.earningRate),
                    }">
                      {{
                        this.assetsArr.earningRate == 0
                        ? this.assetsArr.earningRate
                        : this.formatNum(this.assetsArr.earningRate) + '%'
                      }}
                    </div>
                  </div>
                  <div class="account-overview-td">
                    <span>总IM</span>
                    <div :style="{
                          color: this.setNumberColor(this.assetsArr.totalIm),
                        }">
                      {{
                        this.assetsArr.totalIm == 0
                        ? this.assetsArr.totalIm
                        : this.formatNum(this.assetsArr.totalIm) + '%'
                      }}
                    </div>
                  </div>
                  <div class="account-overview-td maximum-drawdown">
                    <span>总MM</span>
                    <div :style="{
                          color: this.setNumberColor(this.assetsArr.totalMm),
                        }">
                      {{
                        this.assetsArr.totalMm == 0
                        ? this.assetsArr.totalMm
                        : this.formatNum(this.assetsArr.totalMm) + '%'
                      }}
                    </div>
                  </div>
                </div>
                <div class="aErr-overview" v-show="aErrShow">暂无数据</div>
              </div>
            </div>
          </div>
          <div class="goods-box" v-show="allAccountInfoData.length > 0">
            <div class="goods-tittle">
              <span>币种概括 </span>
            </div>

            <div class="account-tittle-bac">
              <div class="account-screening">
                <div class="even-more" v-show="this.coinList.length > 0" style="display: flex">
                  <el-radio-group v-model="symbolRadio" size="mini" @change="coinChange">
                    <el-radio-button v-for="item in coinList.slice(0, coinListIndex)" :key="item.id" :label="item.id">{{
                      item.name }}</el-radio-button>
                  </el-radio-group>
                </div>
                <div class="even-more" v-show="this.coinList.length == 0"
                  style="display: flex; width: 100%; justify-content: center">
                  无币种数据
                </div>
                <div class="few-list" v-show="this.coinList.length >= 7">
                  <div style="display: none" ref="upSymbolRef">
                    <el-button type="primary" @click="upSymbolClick">收起 <i class="el-icon-arrow-up"></i></el-button>
                  </div>
                  <div style="display: flex" ref="downSymbolRef">
                    <el-button type="primary" @click="downSymbolClick">更多<i class="el-icon-arrow-down"></i></el-button>
                  </div>
                </div>
              </div>
              <!-- <div
                class="goods-charts-box trend"
                v-show="this.coinList.length > 0"
              >
                <div class="goods-box-tittle">
                  <span>收益走势 </span>
                </div>

                <div class="goods-total-user-assets">
                  <div class="goods-assets-header">
                    <div class="data-btn-border">
                      <div class="goods-assets-bnt">
                        <el-radio-group
                          @change="yieldTrendChange"
                          class="earningChange"
                          v-model="earningRadio"
                          size="mini"
                        >
                          <el-radio-button label="month"
                            >近一月</el-radio-button
                          >
                          <el-radio-button label="halfYear"
                            >近半年</el-radio-button
                          >
                          <el-radio-button label="year">近一年</el-radio-button>
                          <el-radio-button label="">全部</el-radio-button>
                        </el-radio-group>
                      </div>
                    </div>
                  </div>
                  <div class="goods-assets-body">
                    <div class="goods-charts">
                      <chart class="goods-chart" :option="earningOption" />
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="goods-charts-box" v-show="this.coinList.length > 0">
                <div class="goods-box-tittle">
                  <span>币种信息 </span>
                  <!-- <div class="company">实盘基准：币本位</div> -->
                </div>
                <div class="firm-offer-container">
                  <div class="firm-offer-container-right">
                    <div class="table-tr">
                      <div class="table-td table-td-row-1 table-td-le">
                        <span>Delta</span>
                        <div :style="{
                          color: this.setNumberColor(this.symbolArr.delta),
                        }">
                          {{ this.formatNum(this.symbolArr.delta) }}
                        </div>
                      </div>
                      <div class="table-td table-td-row-1">
                        <span>Gamma</span>
                        <div :style="{
                          color: this.setNumberColor(this.symbolArr.gamma),
                        }">
                          {{ this.formatNum(this.symbolArr.gamma) }}
                        </div>
                      </div>
                      <div class="table-td table-td-row-1">
                        <span>Theta</span>
                        <div :style="{
                          color: this.setNumberColor(this.symbolArr.theta),
                        }">
                          {{ this.formatNum(this.symbolArr.theta) }}
                        </div>
                      </div>
                      <div class="table-td table-td-row-1">
                        <span>Vega</span>
                        <div :style="{
                          color: this.setNumberColor(this.symbolArr.vega),
                        }">
                          {{ this.formatNum(this.symbolArr.vega) }}
                        </div>
                      </div>
                    </div>
                    <!-- <div class="table-tr"> -->
                    <!-- <div class="table-td">
                        <span>IM</span>
                        <div
                          :style="{
                            color: this.setNumberColor(this.symbolArr.im),
                          }"
                        >
                          {{ this.formatNum(this.symbolArr.im) }}
                        </div>
                      </div>
                      <div class="table-td">
                        <span>MM</span>
                        <div
                          :style="{
                            color: this.setNumberColor(this.symbolArr.mm),
                          }"
                        >
                          {{ this.formatNum(this.symbolArr.mm) }}
                        </div>
                      </div> -->
                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <div class="goods-charts-box" v-show="this.coinList.length > 0">
                <div class="information-tabs">
                  <el-tabs class="information-tabs-cl" v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="持仓信息" name="first">
                      <el-table :data="positionInformationData" border :row-class-name="tableRowClassName"
                        class="position-information" style="width: 100%" :header-cell-style="{
                          background: 'rgba(66,67,75,1)',
                          color: 'rgba(237, 189, 136, 1)',
                        }">
                        <el-table-column type="index" width="" align="center" v-if="false"></el-table-column>
                        <el-table-column prop="leverage" label="合约名称" align="center" width="">
                          <template slot-scope="scope">{{
                            scope.row.leverage ? scope.row.leverage : '-'
                          }}</template>
                        </el-table-column>
                        <el-table-column prop="size" label="合约数量" align="center" width="">
                          <template slot-scope="scope">
                            <div class="achieved">
                              {{ scope.row.size ? scope.row.size : '-' }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="entryPrice" label="入场均价(USD)" align="center" width="">
                          <template slot-scope="scope">
                            <div style="display: flex; justify-content: center">
                              <!-- <img
                                class="br-i"
                                src="../../assets/img/rtaLogo/BTC.svg"
                                alt=""
                              /> -->
                              {{
                                scope.row.entryPrice == '0'
                                ? '-'
                                : formatNum(scope.row.entryPrice)
                              }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="markPrice" label="标记价格(USD)" width="" align="center">
                          <template slot-scope="scope">
                            <div style="display: flex; justify-content: center">
                              <!-- <img
                                class="br-i"
                                src="../../assets/img/rtaLogo/BTC.svg"
                                alt=""
                              /> -->

                              {{
                                scope.row.markPrice
                                ? formatNum(scope.row.markPrice)
                                : '-'
                              }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="sessionRPL" label="损益(USD)" align="center" width="">
                          <template slot-scope="scope">
                            <div class="achieved" style="display: flex; justify-content: center" :style="{
                                  color:
                                    scope.row.sessionRPL > 0
                                      ? 'rgba(0, 174, 147, 1)'
                                      : scope.row.sessionRPL == 0
                                        ? 'rgba(209, 212, 220, 1)'
                                        : 'rgba(247, 82, 95, 1)',
                                }">
                              {{
                                scope.row.sessionRPL == '0'
                                ? '-'
                                : formatNum(scope.row.sessionRPL)
                              }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="sessionUPL" label="未实现损益(USD)" width="" align="center">
                          <template slot-scope="scope">
                            <div class="achieved" style="display: flex; justify-content: center" :style="{
                                  color:
                                    scope.row.sessionUPL > 0
                                      ? 'rgba(0, 174, 147, 1)'
                                      : scope.row.sessionUPL == 0
                                        ? 'rgba(209, 212, 220, 1)'
                                        : 'rgba(247, 82, 95, 1)',
                                }">
                              {{
                                scope.row.sessionUPL == '0'
                                ? '-'
                                : formatNum(scope.row.sessionUPL)
                              }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="cumRealisedPnl" label="累计已实现损益(USD)" width="" align="center">
                          <template slot-scope="scope">
                            <div class="achieved" style="display: flex; justify-content: center" :style="{
                                  color:
                                    scope.row.cumRealisedPnl > 0
                                      ? 'rgba(0, 174, 147, 1)'
                                      : scope.row.cumRealisedPnl == 0
                                        ? 'rgba(209, 212, 220, 1)'
                                        : 'rgba(247, 82, 95, 1)',
                                }">
                              {{
                                scope.row.cumRealisedPnl > 0
                                ? formatNum(scope.row.cumRealisedPnl)
                                : scope.row.cumRealisedPnl == '0'
                                  ? '-'
                                  : formatNum(scope.row.cumRealisedPnl)
                              }}
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="历史记录" name="second" class="order-tab-pane">
                      <el-table :data="historyInformationData" border :row-class-name="tableRowClassName"
                        class="position-information" style="width: 100%" :header-cell-style="{
                          background: 'rgba(66,67,75,1)',
                          color: 'rgba(237, 189, 136, 1)',
                        }">
                        <el-table-column type="index" width="" align="center" v-if="false"></el-table-column>
                        <el-table-column prop="symbol" label="合约名称" align="center" width="180">
                          <template slot-scope="scope">{{
                            scope.row.symbol ? scope.row.symbol : '-'
                          }}</template>
                        </el-table-column>
                        <el-table-column prop="side" label="方向" width="100" align="center">
                          <template slot-scope="scope">
                            <div :style="{
                                color:
                                  scope.row.side == '平仓买入' ||
                                    scope.row.side == '开仓买入'
                                    ? 'rgba(0, 174, 147, 1)'
                                    : 'rgba(247, 82, 95, 1)',
                              }">
                              {{ scope.row.side ? scope.row.side : '-' }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="execQty" label="合约数量" align="center" width="100">
                          <template slot-scope="scope">
                            <div class="achieved">
                              {{ scope.row.execQty ? scope.row.execQty : '-' }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="execPrice" label="交易价格" align="center" width="">
                          <template slot-scope="scope">
                            <div style="display: flex; justify-content: center">
                              {{
                                scope.row.execPrice
                                ? formatNum(scope.row.execPrice)
                                : '-'
                              }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="execValue" label="交易金额" align="center" width="">
                          <template slot-scope="scope">
                            <div style="display: flex; justify-content: center">
                              {{
                                scope.row.execValue
                                ? formatNum(scope.row.execValue)
                                : '-'
                              }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="markIv" label="IV (%)" width="" align="center">
                          <template slot-scope="scope">
                            <div style="display: flex; justify-content: center">
                              {{ scope.row.markIv ? scope.row.markIv : '-' }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="indexPrice" label="指数价格" align="center" width="">
                          <template slot-scope="scope">
                            <div class="achieved" style="display: flex; justify-content: center">
                              {{ formatNum(scope.row.indexPrice) }}
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column prop="tradeTime" label="交易时间" sortable width="" align="center">
                        </el-table-column>
                      </el-table>
                    </el-tab-pane>
                  </el-tabs>
                </div>
                <div v-if="historyShow" class="pagingBox">
                  <Paging :pageNum="pageParams.pageNum" :total="total" :pageSize="pageParams.pageSize"
                    @sizeChange="sizeChange" @currentChange="currentChange" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getOptionAccount,
  getOptionSymbol,
  getOptionSymbolEarnings,
  getOptionSymbolPosition,
  getOptionSymbolHistory,
} from '../../api/option';
import Chart from '../../echarts/chart.vue';
import Paging from '../paging/index.vue';
export default {
  components: { Chart, Paging },
  data() {
    return {
      targetUUID: '',
      earningOption: {},
      earningRadio: 'year',
      assetsArr: {
        indexPrice: '12345.67',
        earningScale: '-1.72',
        earnings: '12345.67',
        maxRetreat: '12.34',
        targetChange: '12.34',
        sharpeRate: '0.12',
      },
      firmOffeArr: {
        totalB: '12345.67',
        totalDolar: '1234567.897',
      },
      activeName: 'first',
      orderNum: '0',
      btcImg: {
        btc: '../../assets/img/rtaLogo/BTC.svg',
        btcG: '../../assets/img/rtaLogo/BTC-g.svg',
        btcR: '../../assets/img/rtaLogo/BTC-r.svg',
      },
      positionInformationData: [],
      historyInformationData: [],
      total: 0, //数据总条数
      pageParams: {
        pageNum: 1, //默认第一页
        pageSize: 10, //一页展示10条
      },
      imgUrl: '',
      dataOptions: [
        {
          value: '10FEB23',
          label: '10FEB23',
        },
        {
          value: '09FEB23',
          label: '09FEB23',
        },
        {
          value: '08FEB23',
          label: '08FEB23',
        },
        {
          value: '07FEB23',
          label: '07FEB23',
        },
        {
          value: '06FEB23',
          label: '06FEB23',
        },
      ],
      timeValue: '',
      allAccountInfoData: [
        {
          id: 0,
          name: '',
        },
      ],
      coinList: [
        {
          id: 0,
          name: '',
        },
      ],
      accountRadio: '',
      radioLabel: '',
      symbolRadio: '',
      allAccountInfoDataIndex: 0,
      coinListIndex: 0,
      assetsArr: {
        asset: '',
        earning: '',
        earningRate: '',
        maxRetreat: '',
        totalIm: '',
        totalMm: '',
      },
      timeArr: '',
      YieldTrendDateArr: [],
      dollarStandardData: [],
      symbolPriceData: [],
      symbolArr: {
        delta: '',
        gamma: '',
        // im: '',
        // mm: '',
        theta: '',
        vega: '',
      },
      historyShow: false,
      radio: '',
      accountShow: false,
      aErrShow: false,
      aaa: '未绑定交易所',
    };
  },
  async created() {
    this.findYieldTrend();
    await this.load_data();
  },
  methods: {
    upClick() {
      this.allAccountInfoDataIndex = 7;
      this.$refs.upRef.style.display = 'none';
      this.$refs.downRef.style.display = 'flex';
    },
    downClick() {
      this.allAccountInfoDataIndex = this.allAccountInfoData.length;
      this.$refs.upRef.style.display = 'flex';
      this.$refs.downRef.style.display = 'none';
    },
    upSymbolClick() {
      this.coinListIndex = 7;
      this.$refs.upSymbolRef.style.display = 'none';
      this.$refs.downSymbolRef.style.display = 'flex';
    },
    downSymbolClick() {
      this.coinListIndex = this.allAccountInfoData.length;
      this.$refs.upSymbolRef.style.display = 'flex';
      this.$refs.downSymbolRef.style.display = 'none';
    },
    //数据显示设置不同颜色
    setNumberColor(num) {
      let a = num;
      if (a < 0) {
        return 'rgba(247, 82, 95, 1)';
      }
      if (a > 0) {
        return 'rgba(0, 174, 147, 1)';
      }

      if ((a = 0)) {
        return '#fffff';
      }
    },
    //根据数据显示不同图片
    setImg(num) {
      if (num > 0) return require('../../assets/img/rtaLogo/BTC-g.svg');
      if (num < 0) return require('../../assets/img/rtaLogo/BTC-r.svg');
      else return require('../../assets/img/rtaLogo/BTC.svg');
    },

    //奇偶行背景色不同
    tableRowClassName({ rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return 'oddRow';
      }

      return 'evenRow';
    },

    //登录就显示账户数据
    async load_data() {
      this.allAccountInfoData = this.$store.state.apiNameArr;
      if (this.allAccountInfoData.length == 0) {
        this.accountRadio = '';
        this.accoundFalse = false;
      } else {
        const uuid = this.$route.query.targetUUID;
        this.radio = uuid ? '' : this.allAccountInfoData[0].id;
        this.radioLabel = this.allAccountInfoData[0].id;
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const currentInfo = this.$route.query.userName
        let infoIndex = 7

        if (currentInfo) {
          infoIndex = (userInfo.nickname === currentInfo ? userInfo.nickname : currentInfo).length
        } else {
          infoIndex = userInfo.nickname.lenght
        }

        //账户显示长度判断
        this.allAccountInfoDataIndex =
          infoIndex > 7
            ? 7
            : infoIndex;
        await this.findOptionAccountData('create');
        await this.findSymbolEarningsData();
        await this.findtOptionSymbol();
        await this.findSymbolPositionById();
      }
    },
    //账户筛选
    runkChange(value) {
      this.radio = value;
      this.findOptionAccountData();
      this.findSymbolEarningsData();
      this.findtOptionSymbol();
      this.findSymbolPositionById();
      this.findSymbolHistoryById();
    },
    //获取期权账号概括信息跟币总列表
    async findOptionAccountData(staus = '') {
      let params = {
        targetUUID: this.$route.query.targetUUID,
        accountId: this.radio,
      };
      const { data: res } = await getOptionAccount(params);
      if (res.code == 0) {
        var bb = JSON.stringify(res.data) == '{}';
        if (bb == false) {
          this.accountShow = true;
          this.aErrShow = false;
          this.allAccountInfoData = res.data.account.allAccountInfo;
          if (typeof this.$route.query.targetUUID == 'string') {
            if (staus == 'create')
              this.radioLabel = res.data.account.allAccountInfo[0].id;
          }
          let assets = res.data;
          this.assetsArr.asset = assets.asset;
          this.assetsArr.earning = assets.earning;
          this.assetsArr.earningRate = assets.earningRate;
          this.assetsArr.maxRetreat = assets.maxRetreat;
          this.assetsArr.totalIm = assets.im;
          this.assetsArr.totalMm = assets.mm;

          let coinArr = assets.coinList;
          // console.log(coinArr);
          // if (coinArr.includes('BTC') == false) {
          //   coinArr.unshift('BTC');
          // }
          if (coinArr !== undefined) {
            this.coinList = coinArr.map((item, index) => {
              return {
                id: item,
                name: item,
              };
            });

            if (this.coinList.length == undefined) {
              this.symbolRadio = '';
              this.accoundFalse = false;
            } else {
              this.symbolRadio = this.coinList[0].id;
              //账户显示长度判断
              this.coinListIndex =
                this.coinList.length > 7 ? 7 : this.coinList.length;
            }
          }
        } else {
          this.allAccountInfoData = this.$store.state.newApiNameArr;
          this.radioLabel = this.allAccountInfoData[0].id;
          this.accountShow = false;
          this.aErrShow = true;
          this.assetsArr.asset = '';
          this.assetsArr.earning = '';
          this.assetsArr.earningRate = '';
          this.assetsArr.maxRetreat = '';
          this.assetsArr.totalIm = '';
          this.assetsArr.totalMm = '';
          this.coinList = [];
        }
      } else if (res.code == 10006) {
        this.allAccountInfoData = [];
        this.aaa = '用户等级不足，不可以访问该信息！';
      } else {
      }
    },
    //币种筛选
    coinChange(value) {
      this.symbolRadio = value;
      this.dollarStandardData = [];
      this.symbolPriceData = [];
      this.symbolArr.delta = '';
      this.symbolArr.gamma = '';
      this.symbolArr.im = '';
      this.symbolArr.mm = '';
      this.symbolArr.theta = '';
      this.symbolArr.vega = '';
      this.positionInformationData = [];
      this.findSymbolEarningsData();
      this.findtOptionSymbol();
      this.findSymbolPositionById();
    },
    //收益率走势date切换事件
    yieldTrendChange(value) {
      this.earningRadio = value;
      this.findSymbolEarningsData();
    },
    //获取标的收益曲线数据
    async findSymbolEarningsData() {
      let params = {
        targetUUID: this.$route.query.targetUUID,
        accountId: this.radio,
        queryTime: this.earningRadio,
        symbol: this.symbolRadio,
      };
      const { data: res } = await getOptionSymbolEarnings(params);
      // console.log(res.data);
      if (res.code == 0) {
        this.YieldTrendDateArr = res.data.map((v) =>
          this.dateTypeFormat('YYYY-mm-dd HH:MM', new Date(v.createTime))
        );
        this.dollarStandardData = res.data.map((v) =>
          v.totalRpl == null ? '0' : v.totalRpl
        );
        this.symbolPriceData = res.data.map((v) =>
          v.symbolPrice == null ? '0' : v.symbolPrice
        );
        // console.log(this.dollarStandardData, this.symbolPriceData);
        this.findYieldTrend();
      }
    },
    // 收益率走势展示
    findYieldTrend() {
      const xData = this.YieldTrendDateArr;
      const dollarYield = this.dollarStandardData;
      const indexPrice = this.symbolPriceData;
      this.earningOption = {
        color: 'rgba(0, 174, 147, 1)',
        tooltip: {
          trigger: 'axis',
          borderWidth: '0', //边框宽度设置1
          borderColor: 'none', //设置边框颜色
          //formatter: '{b} <br/><br/>{a0}:{c0}%<br/>{a1}:{c1}%<br/>{a2}:{c2}%',
          formatter: (params) => {
            let result = `${params[0].name}<br>`;
            params.forEach((item) => {
              if (item.seriesName === '美元本位') {
                if (item.value > 1000 && item.value <= 1000000) {
                  result += `${item.seriesName
                    } : <span style="font-size:16px;">${(
                      item.value / 1000
                    ).toFixed(4)}K</br>`;
                } else if (item.value > 1000000 && item.value <= 1000000000) {
                  result += `${item.seriesName
                    } : <span style="font-size:16px;">${(
                      item.value / 1000000
                    ).toFixed(4)}M</br>`;
                } else if (item.value > 1000000000) {
                  result += `${item.seriesName
                    } : <span style="font-size:16px;">${(
                      item.value / 1000000000
                    ).toFixed(4)}B</br>`;
                } else {
                  result += `${item.seriesName} : <span style="font-size:16px;">${item.value}</br>`;
                }
              } else {
                result += `${item.seriesName} : <span style="font-size:16px;">${item.value}</br>`;
              }
            });
            return result;
          },
          padding: 20,
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal',
            color: 'rgba(209, 212, 220, 1)', //设置文字颜色
          },
          extraCssText: 'background:rgba(61, 63, 71, 1);',
        },
        legend: {
          icon: 'roundRect',
          padding: [4, 0, 4, 0],
          itemGap: 40,
          itemWidth: 16,
          itemHeight: 16,
          textStyle: {
            fontSize: 14,
            color: 'rgba(209, 212, 220, 1)',
          },
          show: true,
          data: ['美元本位', '指数价格'],
          selected: { 美元本位: true, 指数价格: true },
          // selectedMode: 'single',
        },
        grid: {
          top: '15%',
          left: '2%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xData.reverse(),
          offset: 12,
          axisLabel: {
            textStyle: {
              color: 'rgba(209, 212, 220, 1)',
            },
          },
        },
        yAxis: [
          {
            name: '美元本位',
            type: 'value',
            scale: true,
            // min: 'dataMin',
            // max: 'dataMax',
            offset: 12,
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ['rgba(159, 159, 159, 0.1)'],
              },
            },
            axisLabel: {
              formatter: function (v) {
                if (v > 1000 && v <= 1000000) {
                  return v / 1000 + 'K';
                } else if (v > 1000000 && v <= 1000000000) {
                  return v / 1000000 + 'M';
                } else if (v > 1000000000) {
                  return v / 1000000000 + 'B';
                } else {
                  return v;
                }
                // return v + 'K';
              },
              textStyle: {
                color: 'rgba(209, 212, 220, 1)',
              },
            },
          },
          {
            name: '指数价格',
            type: 'value',
            scale: true,
            // min: 'dataMin',
            // max: 'dataMax',
            offset: 12,
            splitLine: {
              //show:false,
              lineStyle: {
                type: [5, 10],
                dashOffset: 5,
                //type:'dashed',
                // 使用深浅的间隔色
                color: ['rgba(159, 159, 159, 0.1)'],
              },
            },
            axisLabel: {
              textStyle: {
                color: 'rgba(209, 212, 220, 1)',
              },
            },
          },
        ],
        series: [
          {
            name: '美元本位',
            data: dollarYield.reverse(),
            // data: [122222,255555,122222,255555122222,255555122222,255555122222,255555122222,255555122222,255555],
            type: 'line',
            showSymbol: false,
            lineStyle: {
              color: 'rgba(0, 174, 147, 1)',
            },
            itemStyle: {
              color: 'rgba(0, 174, 147, 1)',
            },
            yAxisIndex: 0,
          },
          {
            name: '指数价格',
            data: indexPrice.reverse(),
            type: 'line',
            showSymbol: false,

            lineStyle: {
              color: 'rgba(247, 82, 95, 1)',
            },
            itemStyle: {
              color: 'rgba(247, 82, 95, 1)',
            },
            yAxisIndex: 1,
          },
        ],
      };
    },
    //获取币种信息
    async findtOptionSymbol() {
      let params = {
        targetUUID: this.$route.query.targetUUID,
        accountId: this.radio,
        symbol: this.symbolRadio,
      };
      const { data: res } = await getOptionSymbol(params);

      if (res.code == 0) {
        var aa = JSON.stringify(res.data) == '{}';
        if (aa == false) {
          this.symbolArr.delta = parseFloat(res.data.delta).toFixed(5);
          this.symbolArr.gamma = parseFloat(res.data.gamma).toFixed(5);
          this.symbolArr.theta = parseFloat(res.data.theta).toFixed(5);
          this.symbolArr.vega = parseFloat(res.data.vega).toFixed(5);
        } else {
          this.symbolArr.delta = '';
          this.symbolArr.gamma = '';
          this.symbolArr.theta = '';
          this.symbolArr.vega = '';
        }
      } else {
        this.symbolArr.delta = 0;
        this.symbolArr.gamma = 0;
        this.symbolArr.theta = 0;
        this.symbolArr.vega = 0;
      }
    },

    //持仓订单选项卡切换
    handleClick(tab, event) {
      this.positionInformationData = [];
      this.historyInformationData = [];
      if (this.activeName == 'first') {
        this.findSymbolPositionById();
        this.historyShow = false;
      } else {
        this.historyShow = true;
        this.findSymbolHistoryById();
      }
    },

    //获取标的期权持仓信息所有数据
    async findSymbolPositionById() {
      this.positionInformationData = [];
      let params = {
        targetUUID: this.$route.query.targetUUID,
        accountId: this.radio,
        symbol: this.symbolRadio,
      };
      const { data: res } = await getOptionSymbolPosition(params);

      if (res.code == 0) {
        let positionInformation = res.data;
        positionInformation.forEach((item) => {
          const positionObj = {
            leverage: item.leverage == null ? '0' : item.leverage,
            size: item.size == null ? '0' : item.size,
            entryPrice:
              item.entryPrice == null ? '0' : this.Decimals(item.entryPrice, 2),
            markPrice:
              item.markPrice == null ? '0' : this.Decimals(item.markPrice, 2),
            sessionRPL:
              item.sessionRPL == null ? '0' : this.Decimals(item.sessionRPL, 2),
            sessionUPL:
              item.sessionUPL == null ? '0' : this.Decimals(item.sessionUPL, 2),
            cumRealisedPnl:
              item.cumRealisedPnl == null
                ? '0'
                : this.Decimals(item.cumRealisedPnl, 2),
          };
          this.positionInformationData.push(positionObj);
          // console.log(this.positionInformationData);
        });
      }
    },

    //获取历史数据所有数据
    async findSymbolHistoryById() {
      let params = {
        targetUUID: this.$route.query.targetUUID,
        accountId: this.radio,
        symbol: this.symbolRadio,
        pageIndex: this.pageParams.pageNum,
        pageSize: this.pageParams.pageSize,
      };
      const { data: res } = await getOptionSymbolHistory(params);

      if (res.code == 0) {
        let historyInformation = res.data;
        this.total = res.total;
        historyInformation.forEach((item) => {
          const positionObj = {
            symbol: item.symbol,
            side: item.side,
            execPrice:
              item.execPrice == null ? '0' : this.Decimals(item.execPrice, 2),
            execQty: item.execQty,
            execValue:
              item.execValue == null ? '0' : this.Decimals(item.execValue, 2),
            markIv: (item.markIv * 100).toFixed(2),
            indexPrice:
              item.indexPrice == null ? '0' : this.Decimals(item.indexPrice, 2),
            tradeTime: this.dateTypeFormat(
              'YYYY-mm-dd HH:MM',
              new Date(item.tradeTime)
            ),
          };
          this.historyInformationData.push(positionObj);
        });
      }
    },
    // 历史数据点击页码及上一页下一页按钮操作
    currentChange(val) {
      this.pageParams.pageNum = val;
      this.historyInformationData = [];
      this.findSymbolHistoryById();
    },
    // 每页显示的记录数切换事件
    sizeChange(val) {
      this.pageParams.pageSize = val;
      this.historyInformationData = [];
      this.findSymbolHistoryById();
    },
  },
};
</script>
<style lang="scss">
.oddRow {
  //斑马纹样式

  color: white;

  background-color: rgba(102, 102, 102, 0.1) !important;

  .el-table__cell {
    padding: 0 !important;
    margin: 0 !important;

    .cell {
      font-size: 14px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #d1d4dc;
    }
  }
}

.evenRow {
  background-color: rgba(255, 255, 255, 0.1) !important;

  color: white;

  .el-table__cell {
    padding: 0 !important;
    margin: 0 !important;

    .cell {
      font-size: 14px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #d1d4dc;
    }
  }
}
</style>
<style lang="scss" scope>
.indivdual-all-lbe {
  .goods-body-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin: 0 auto;

    // padding-bottom: 182px;
    .goods-body-box {
      display: flex;
      width: 100%;
      height: 100%;

      .goods-container-row {
        width: 100%;
        height: 100%;

        .goods-box {
          text-align: left;
          margin-top: 32px;

          .goods-tittle {
            height: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 16px;

            span {
              font-size: 16px;
              font-family: MicrosoftYaHei;
              color: #d1d4dc;
              cursor: pointer;
            }

            .company {
              margin-top: 9px;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(209, 212, 220, 0.7);
            }
          }

          .account-tittle-bac {
            margin-top: 16px;
            // width: 100%;

            border-radius: 4px;
            flex-direction: column;
            display: flex;

            .account-screening {
              //width: 100%;
              display: flex;
              justify-content: space-between;
              margin: 0 0 32px 0;

              .even-more {
                width: 100%;

                .el-radio-group {
                  .el-radio-button {
                    width: 120px;
                    height: 40px;
                    padding: 0 !important;

                    margin: 0 4px 4px 0;

                    .el-radio-button__inner {
                      border-radius: 2px;
                      margin: 0;
                      padding: 0;
                      width: 120px;
                      height: 40px;
                      line-height: 40px;
                      background: transparent;
                      font-size: 14px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #d1d4dc;
                      border: 1px solid rgba(151, 151, 151, 0.5);
                    }

                    .el-radio-button__inner:focus {
                      background: rgba(237, 189, 136, 1) !important;
                      color: #33353e;
                      border: none;
                    }

                    .el-radio-button__inner:hover {
                      background: transparent;
                      color: #edbd88;
                      border: 1px solid #edbd88;
                      border-radius: 2px;
                    }

                    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                      background: rgba(237, 189, 136, 1);
                      color: #33353e;
                    }

                    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                      border-color: none;
                      -webkit-box-shadow: none;
                      box-shadow: none;
                    }
                  }
                }
              }

              .few-list {
                height: 40px;

                .el-button {
                  margin: 0;
                  padding: 0;
                  width: 74px;
                  height: 32px;
                  border-radius: 4px;
                  border: 1px solid rgba(209, 212, 220, 0.5);
                  background: transparent;

                  span {
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: rgba(209, 212, 220, 1);
                  }
                }
              }
            }

            .account-overview {
              width: 100%;
              background: rgba(65, 67, 75, 1);
              display: flex;
              border-radius: 0px 0px 4px 4px;

              .account-overview-td {
                width: 100%;
                height: 100%;
                margin: 20px 0 30px 24px;
                border-right: 1px solid rgba(255, 255, 255, 0.1);

                span {
                  font-size: 13px;
                  font-family: MicrosoftYaHei;
                  color: #d1d4dc;
                }

                div {
                  margin-top: 4px;
                  font-size: 24px;
                  font-family: DIN-Medium, DIN;
                  font-weight: 500;
                  color: #d1d4dc;
                }
              }

              .maximum-drawdown {
                border-right: none !important;
              }
            }

            .aErr-overview {
              width: 100%;
              border-radius: 4px;
              display: flex;
              justify-content: center;
            }

            .trend {
              display: none !important;
              margin-top: 12px !important;
            }

            .goods-charts-box {
              text-align: left;

              // margin: 12px 20px 20px 20px;
              .goods-box-tittle {
                font-size: 16px;
                font-family: MicrosoftYaHei;
                color: #d1d4dc;
              }

              .goods-total-user-assets {
                color: #d1d4dc !important;
                margin-top: 20px;
                width: 100%;
                height: 100%;
                background: rgba(70, 72, 79, 1);
                border-radius: 8px;

                .analysis-box {
                  width: 100%;
                  height: 160px;
                  display: flex;

                  .analysis-btn {
                    margin: 37px 32px;
                    height: 88px;
                    width: 336px;

                    span {
                      font-size: 16px;
                      font-family: MicrosoftYaHei;
                      color: #d1d4dc;
                    }

                    .up-down {
                      height: 20px;
                      font-size: 16px;
                      font-family: Roboto-Regular, Roboto;
                      font-weight: 400;
                      color: #00ae93;
                      line-height: 20px !important;
                      display: flex;

                      img {
                        margin-top: 3px;
                      }
                    }

                    .total-price {
                      height: 44px;
                      font-size: 36px;
                      font-family: DIN-Medium, DIN;
                      font-weight: 500;
                      color: #d1d4dc;
                      line-height: 44px;
                    }
                  }
                }

                .goods-assets-header {
                  padding: 24px 32px 0 32px;

                  .data-btn-border {
                    width: 100%;
                    padding-bottom: 24px;
                    display: flex;
                    justify-content: flex-end;
                    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

                    .goods-assets-bnt {
                      .earningChange {
                        .el-radio-button {
                          width: 69px;
                          height: 32px;
                          border-radius: 16px;
                          padding: 0 !important;
                          margin: 0 !important;

                          .el-radio-button__inner {
                            width: 69px;
                            height: 32px;
                            background: transparent;
                            font-size: 13px;
                            font-family: MicrosoftYaHei;
                            color: #d1d4dc;
                            line-height: 17px;
                            border: none;
                          }

                          .el-radio-button__inner:focus {
                            background: #33353e !important;
                            border-radius: 16px;
                            border: none;
                          }

                          .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                            background: #33353e;
                            border-radius: 16px;
                            border: none;
                          }

                          .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                            border-color: none;
                            -webkit-box-shadow: none;
                            box-shadow: none;
                          }
                        }
                      }
                    }
                  }
                }

                .goods-assets-body {

                  // .major-data {
                  //   margin: 23px 32px 60px 32px;
                  //   display: flex;
                  //   .index-price {
                  //     width: fit-content;
                  //     span {
                  //       font-size: 13px;
                  //       font-family: MicrosoftYaHei;
                  //       color: #d1d4dc;
                  //     }
                  //     .index-data {
                  //       font-size: 16px;
                  //       font-family: Roboto-Regular, Roboto;
                  //       font-weight: 400;
                  //       color: rgba(209, 212, 220, 1);
                  //       width: fit-content;
                  //       margin-right: 60px;
                  //       line-height: 22px;
                  //     }
                  //   }
                  // }
                  .goods-charts {
                    padding: 48px 32px 32px;
                  }
                }
              }

              .firm-offer-container {
                margin-top: 16px;
                display: flex;

                .firm-offer-container-right {
                  width: 100%;
                  height: 100%;

                  .table-tr {
                    display: flex;

                    .table-td-le {
                      margin-left: 0px !important;
                    }

                    .table-td {
                      margin-left: 20px;
                      width: 100%;
                      height: 100%;
                      background: rgba(65, 67, 75, 1);
                      border-radius: 4px;
                      padding: 20px 32px 30px;

                      span {
                        font-size: 13px;
                        font-family: MicrosoftYaHei;
                        color: #d1d4dc;
                      }

                      div {
                        margin-top: 4px;
                        font-size: 24px;
                        font-family: DIN-Medium, DIN;
                        font-weight: 500;
                        color: #d1d4dc;
                        margin-top: 4px;
                      }
                    }

                    .table-td-row-1 {
                      margin-bottom: 20px;
                    }
                  }
                }
              }

              .information-tabs {
                width: 100%;

                .information-tabs-cl {
                  .el-tabs__header {
                    padding: 40px 0px 0;
                    margin: 0 !important;

                    .el-tabs__nav-wrap {
                      .el-tabs__nav-scroll {
                        border-bottom: none;

                        .el-tabs__nav {
                          width: 100%;
                          height: 48px;
                          display: flex;

                          .el-tabs__active-bar {
                            display: none;
                          }

                          .el-tabs__item.is-active {
                            font-size: 16px;
                            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                            font-weight: bold;
                            color: #33353e;
                            background: rgba(237, 189, 136, 1);
                          }

                          .el-tabs__item {
                            line-height: 48px;
                            width: 580px;
                            height: 48px;
                            background: rgba(255, 255, 255, 0.1);
                            font-size: 16px;
                            font-family: MicrosoftYaHei;
                            color: #d1d4dc;
                            margin-bottom: 0;
                            text-align: center;
                          }
                        }
                      }
                    }

                    .el-tabs__nav-wrap::after {
                      display: none !important;
                    }
                  }

                  .el-tabs__content {
                    margin: 0 0 32px 0;

                    .el-tab-pane {
                      .position-information {
                        .el-table__header-wrapper {
                          display: block !important;

                          .el-table__header {
                            .has-gutter {
                              tr {
                                height: 48px !important;

                                .el-table__cell {
                                  padding: 0 !important;

                                  .cell {
                                    height: 48px !important;
                                    line-height: 48px !important;
                                  }
                                }

                                .gutter {
                                  background: rgba(102,
                                      102,
                                      102,
                                      0.1) !important;
                                  border-bottom: none;
                                }
                              }
                            }
                          }
                        }

                        // .is-scrolling-left {
                        //   display: none !important;
                        // }
                        .el-table__body-wrapper {

                          //display: none !important;
                          //height: 336px !important;
                          // display: none !important;
                          .el-table__body tr:hover>td {
                            background: rgba(237, 189, 136, 1) !important;

                            .cell {
                              color: #33353e !important;
                              font-size: 14px;
                              font-family: Roboto-Regular, Roboto;
                              font-weight: 400;

                              .achieved {
                                color: #33353e !important;
                              }

                              img {
                                //filter: drop-shadow(0px 150px 0px #33353E);
                                transform: translateX(-100px);
                                filter: drop-shadow(#33353e 100px 0);
                              }
                            }
                          }

                          .el-table__body {
                            tr {
                              height: 48px !important;

                              th {
                                .cell {
                                  .caret-wrapper {
                                    .sort-caret {
                                      border-top-color: rgba(237,
                                          189,
                                          136,
                                          1) !important;
                                    }
                                  }
                                }
                              }

                              td {
                                .cell {
                                  line-height: 23px !important;

                                  img {
                                    overflow: hidden;
                                  }
                                }
                              }
                            }
                          }
                        }
                      }

                      .time-select {
                        .el-select {
                          .el-input {
                            .el-input__inner {
                              border: none !important;
                              background: transparent !important;
                              font-size: 16px !important;
                              font-family: Roboto-Medium, Roboto;
                              font-weight: 500;
                              color: #d1d4dc;
                              padding: 0 0 0 0;
                            }

                            .el-input__suffix {
                              .el-input__suffix-inner {
                                .el-input__icon {
                                  width: 10px !important;
                                }

                                .el-icon-arrow-up:before {
                                  content: '' !important;
                                  background: url(../../assets/img/rtaLogo/select-up.svg) center center no-repeat;
                                  position: absolute;
                                  width: 100%;
                                  height: 100%;
                                  top: 50%;
                                  left: 50%;
                                  transform: translate(-50%, -50%);
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }

              .pagination-in {
                margin-top: 40px !important;
                text-align: center;

                .el-pagination.is-background .btn-next,
                .el-pagination.is-background .btn-prev,
                .el-pagination.is-background .el-pager li {
                  margin: 0 5px;
                  background-color: rgba(80, 82, 89, 1) !important;
                  color: #d1d4dc;
                  min-width: 32px;
                  min-height: 32px;
                  border-radius: 2px;
                }

                .el-pagination {
                  .el-pagination__sizes {
                    .el-select {
                      .el-input {
                        .el-input__inner {
                          height: 32px;
                          border: none !important;
                          background-color: rgba(80, 82, 89, 1) !important;
                          color: #d1d4dc;
                        }
                      }
                    }
                  }

                  .el-pager {
                    li {
                      padding: 4px 4px;
                    }
                  }

                  .el-pager li:not(.disabled):hover {
                    color: rgba(51, 53, 62, 1) !important;
                    background: #edbd88 !important;
                  }

                  .el-pager li:not(.disabled).active {
                    color: rgba(51, 53, 62, 1) !important;
                    background: #edbd88 !important;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/individualOption/IndividualOption.vue